import {
    GET_TEAMS_LOADING, GET_TEAMS_SUCCESS, GET_TEAMS_ERROR,
    GET_MIN_TEAMS_LOADING, GET_MIN_TEAMS_SUCCESS, GET_MIN_TEAMS_ERROR
} from "../../../constant/actionTypes";

const teamReducer = (state = {}, action) => {
    switch (action.type) {
        case GET_TEAMS_LOADING: {
            let obj = {
                loading: true
            };
            return obj;
        }

        case GET_TEAMS_SUCCESS: {
            let obj = {
                loading: false,
                data: action.response.teams,
            };
            return obj;
        }

        case GET_TEAMS_ERROR: {
            let obj = {
                loading: false,
                status: action.response
            };
            return obj;
        }

        case GET_MIN_TEAMS_LOADING: {
            let obj = {
                loading: true
            };
            return obj;
        }

        case GET_MIN_TEAMS_SUCCESS: {
            let obj = {
                loading: false,
                data: action.response.teams,
            };
            return obj;
        }
        case GET_MIN_TEAMS_ERROR: {
            let obj = {
                loading: false,
                status: action.response
            };
            return obj;
        }
        default:
            return state;
    }
}

export default teamReducer;